// extracted by mini-css-extract-plugin
export default {"symbol":"CurrencySymbol_symbol__bKamG","symbolSvg":"CurrencySymbol_symbolSvg__QDMo4"};